'use strict';

const serviceName = 'Listings';

// Below files are included in index.template.html
require('@pinmeto/ui/dist/pmt-instrumentation');
window.PinMeToInstrumentation.init(
	`${serviceName}.frontend`,
	window.pmtVersionCheckHash,
	window.pmtEnv
);

require('@pinmeto/ui/dist/pmt-logger');

PinMeToLogger.init(window.PinMeToInstrumentation.log);

// pmt-crisp uses PinMeToLogger so it needs to be included after the logger is initialized
require('@pinmeto/ui/dist/pmt-crisp');
// pmt-plantrack is a script used by Planhat
require('@pinmeto/ui/dist/pmt-plantrack.js');

// Below files generate static/js/places.js in Grunt.
require('./pmtPlacesApp.js');
require('./components/**/*.js');
require('./js/**/*.js');
require('./shared/**/*.js');

// Below svg file is included in Grunt
import('@pinmeto/ui/dist/svg/icons.svg').then(({ default: svg }) => {
	const el = document.getElementById('pmt-svg-icons');
	if (el) {
		el.innerHTML = svg;
	}
});
